import React from 'react';
import { STATUS_CATEGORY_COLORS } from '../types/playbook.types';
import type { PlaybookStatusCategory } from '../types/playbook.types';

interface PlaybookStatusBadgeProps {
  category: PlaybookStatusCategory | 'blocked';
  name: string;
  size?: 'sm' | 'md';
}

const PlaybookStatusBadge: React.FC<PlaybookStatusBadgeProps> = ({ category, name, size = 'sm' }) => {
  const colors = STATUS_CATEGORY_COLORS[category] || STATUS_CATEGORY_COLORS.todo;
  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClasses} ${colors.bg} ${colors.text} ${colors.border} ${colors.darkBg} ${colors.darkText} ${colors.darkBorder} border`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${colors.dot}`} />
      {name}
    </span>
  );
};

export default PlaybookStatusBadge;
